import React from 'react';
import AsyncSelect from 'react-select/lib/Async';
import {bindActionCreators} from "redux";
import {employeeAssignmentsList} from "../../actions/employee_assignments";
import {handleApiResponse, selectResource} from "../../../../common/js/crud-actions";
import connect from "react-redux/es/connect/connect";
import {searchEmployee} from "../../actions/employee";

class EmployeeSelect extends React.Component {

    constructor(params) {
        super(params);

        this.selectRef = React.createRef();

        this.state = {
            inputValue: '',
            initial: true
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { value, inputValue } = this.state;

        if ( value && nextProps.value !==  value.value ) {
            this.setState({ initial: true });
        }
    }

    handleInputChange = (newValue) => {
        this.setState({ inputValue: newValue });
        return newValue;
    };

    handleChange = (change) => {
        this.setState({ value: change });
        this.props.onChange(change ? change.value : null);
    };

    loadOptions = (inputValue, callback) => {
        if (this.state.initial) {
            if (!this.props.value || this.props.value === '') {
                this.setState({ value: null, initial: false });
                callback([]);
                return;
            }

            let promise = this.props.searchEmployee(this.props.value, true);
            handleApiResponse('EMPLOYEES', 'SEARCH', promise,
                (result) => {
                    let resultList = result.payload.list.map((employee) => {
                        return {
                            value: employee.personal_id,
                            label: `${employee.name} ${employee.surname} - ${employee.personal_id}`
                        }
                    });

                    callback(resultList);

                    if (this.props.value && resultList[0] && resultList[0].value === this.props.value) {
                        this.setState({ value: resultList[0], initial: false });
                    } else {
                        this.setState({ value: { value: this.props.value, label: this.props.value }, initial: false });
                    }
                }, (result) => { callback([]); }, (error) => { console.log(error); callback([]); });


        } else {
            let promise = this.props.searchEmployee(inputValue);
            handleApiResponse('EMPLOYEES', 'SEARCH', promise,
                (result) => {
                    let resultList = result.payload.list.map((employee) => {
                        return {
                            value: employee.personal_id,
                            label: `${employee.name} ${employee.surname} - ${employee.personal_id}`
                        }
                    });

                    callback(resultList);
                }, (result) => { console.log(result); callback([]); }, (error) => { console.log(error); callback([]); });
        }
    };

    render() {
        const isClearable = this.state.value && this.state.value.value && this.state.value.value !== '';

        return (
            <div>
                <AsyncSelect
                    key={this.props.value}
                    ref={this.selectRef}
                    className='user-select-container'
                    classNamePrefix='user-select'
                    loadOptions={this.loadOptions}
                    defaultOptions
                    onInputChange={this.handleInputChange}
                    onChange={this.handleChange}
                    value={ this.state.value }
                    inputValue={ this.state.inputValue }
                    isClearable={ isClearable }
                />
            </div>
        );
    }
}


function mapStateToProps(state,ownProps) {
    return {
        employees: state.employees,
        employee_assignments: state.employee_assignments
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        employeeAssignmentsList: employeeAssignmentsList,
        selectResource: selectResource,
        searchEmployee: searchEmployee
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(EmployeeSelect);
